// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .modalStyle .ng-star-inserted {
  background: none;
}
::ng-deep .modalStyle .ant-modal-body {
  margin: 0px;
  padding: 0px;
}
::ng-deep .modalStyle .ant-modal-content {
  width: 260px;
  background: transparent;
}
::ng-deep .modalStyle .ant-modal-footer {
  margin-left: auto;
  margin-right: auto;
  border: none;
}
@media (max-width: 480px) {
  ::ng-deep .checklist .list-item {
    position: relative;
    z-index: 1;
  }
  ::ng-deep .checklist .circle-icon {
    position: relative;
    z-index: 2;
  }
  ::ng-deep .modalStyle .ant-modal {
    top: 11vh;
  }
  ::ng-deep .modalStyle .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.25);
  }
  ::ng-deep .modalStyle .ant-modal-content {
    margin: 0 auto;
    background: transparent;
  }
  ::ng-deep .modalStyle .ant-modal-close {
    visibility: hidden;
  }
  ::ng-deep .modalStyle .ant-modal-header {
    background: #fff;
    padding: 24px 20px;
    border: none;
    text-align: center;
    border: none;
  }
  ::ng-deep .modalStyle .ant-modal-header .ant-modal-title {
    font-size: 14px;
    line-height: 16px;
  }
  ::ng-deep .modalStyle .ant-modal-body {
    background: #fff;
    padding: 10px 20px 30px;
  }
  ::ng-deep .modalStyle .checklist .list-item {
    margin-bottom: 10px;
  }
  ::ng-deep .modalStyle .checklist .circle-icon {
    display: inline-block;
    margin-right: 8px;
    position: relative;
    vertical-align: middle;
    width: 16px;
    height: 16px;
  }
  ::ng-deep .modalStyle .checklist .circle-icon:after {
    content: "";
    border: solid 2px #d8d8d8;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  ::ng-deep .modalStyle .checklist .circle-icon i {
    display: block;
    font-size: 10px;
    background-color: #4cb8ac;
    color: #fff;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    z-index: 1;
    position: relative;
    vertical-align: middle;
    line-height: 16px;
    padding: 2px 0 0 0;
  }
  ::ng-deep .modalStyle .ant-modal-footer {
    background: transparent;
    padding: 0px;
    border: none;
  }
  ::ng-deep .modalStyle .ant-modal-footer .ant-btn {
    border: none;
    width: 50%;
    margin: 0;
    height: 50px;
    border-radius: 0;
    color: #4cb8ac;
    background-color: white;
    font-size: 16px;
    font-weight: 400;
    vertical-align: middle;
  }
  ::ng-deep .modalStyle .ant-modal-footer .ant-btn:hover {
    background-color: #4cb8ac;
    color: white;
  }
  ::ng-deep .modalStyle .ant-modal-footer .ant-btn-primary {
    color: white;
    background-color: #4cb8ac;
    font-weight: 600;
  }
  ::ng-deep .modalStyle .ant-modal-footer .ant-btn-primary:hover {
    background-color: white;
    color: #4cb8ac;
  }
  ::ng-deep [nz-radio] {
    display: block;
  }
}

[nz-radio] {
  height: 32px;
  line-height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/sharedmodule/components/select-modal/select-modal.component.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;AADN;AAGI;EACA,WAAA;EACA,YAAA;AADJ;AAMI;EACE,YAAA;EACA,uBAAA;AAJN;AAMI;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AAJN;AAQE;EAEI;IACE,kBAAA;IACA,UAAA;EAPN;EASI;IACE,kBAAA;IACA,UAAA;EAPN;EAWI;IACE,SAAA;EATN;EAWI;IACE,qCAAA;EATN;EAWE;IACE,cAAA;IACA,uBAAA;EATJ;EAWE;IACE,kBAAA;EATJ;EAYI;IACE,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;EAVN;EAWM;IACE,eAAA;IACA,iBAAA;EATR;EAYI;IACE,gBAAA;IACA,uBAAA;EAVN;EAaM;IACE,mBAAA;EAXR;EAaM;IACE,qBAAA;IACA,iBAAA;IACA,kBAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;EAXR;EAYQ;IACE,WAAA;IACA,yBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,cAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;EAVV;EAaQ;IACE,cAAA;IACA,eAAA;IACA,yBAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,UAAA;IACA,kBAAA;IACA,sBAAA;IACA,iBAAA;IACA,kBAAA;EAXV;EAeI;IACE,uBAAA;IACA,YAAA;IACA,YAAA;EAbN;EAcM;IACE,YAAA;IACA,UAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;EAZR;EAaQ;IACE,yBAAA;IACA,YAAA;EAXV;EAcM;IACE,YAAA;IACA,yBAAA;IACA,gBAAA;EAZR;EAaQ;IACE,uBAAA;IACA,cAAA;EAXV;EAiBE;IACE,cAAA;EAfJ;AACF;;AAmBA;EAEE,YAAA;EACA,iBAAA;AAjBF","sourcesContent":["::ng-deep{\n  .modalStyle{\n    .ng-star-inserted{\n      background: none;\n    }\n    .ant-modal-body {\n    margin: 0px;\n    padding: 0px;\n    }\n    \n    \n    \n    .ant-modal-content {\n      width: 260px;\n      background: transparent;\n    }\n    .ant-modal-footer {\n      margin-left: auto;\n      margin-right: auto;\n      border: none;\n    }\n\n  }\n  @media (max-width:480px) {\n    .checklist{\n      .list-item{ \n        position:relative;\n        z-index: 1;\n      }\n      .circle-icon{\n        position:relative;\n        z-index: 2;\n      }\n    }\n    .modalStyle{\n      .ant-modal{\n        top: 11vh;\n      }\n      .ant-modal-mask{\n        background-color: rgba(0,0,0,0.25);\n      }\n    .ant-modal-content{\n      margin:0 auto;\n      background: transparent;\n    }\n    .ant-modal-close{\n      visibility: hidden;\n    }  \n\n      .ant-modal-header{\n        background: #fff;\n        padding: 24px 20px;\n        border: none;\n        text-align: center;\n        border: none;\n        .ant-modal-title{\n          font-size:14px;\n          line-height:16px;\n        }\n      }\n      .ant-modal-body{\n        background: #fff;\n        padding: 10px 20px 30px; \n      }\n      .checklist{\n        .list-item{\n          margin-bottom:10px;\n        }\n        .circle-icon{ \n          display: inline-block;\n          margin-right: 8px;\n          position: relative;\n          vertical-align: middle;\n          width: 16px;\n          height: 16px;\n          &:after{\n            content: \"\";\n            border: solid 2px #d8d8d8;\n            width: 16px;\n            height: 16px;\n            border-radius: 10px;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n          }\n\n          i{ \n            display: block;\n            font-size: 10px;\n            background-color: #4cb8ac;\n            color: #fff;\n            width: 16px;\n            height: 16px;\n            border-radius: 10px;\n            z-index: 1;\n            position: relative;\n            vertical-align: middle;\n            line-height: 16px;\n            padding: 2px 0 0 0;\n          }\n        }\n      }\n      .ant-modal-footer{ \n        background: transparent; \n        padding:0px;\n        border: none;\n        .ant-btn{  \n          border: none; \n          width: 50%;\n          margin: 0;\n          height: 50px;\n          border-radius: 0;\n          color: #4cb8ac;\n          background-color: white;    \n          font-size: 16px;\n          font-weight: 400;\n          vertical-align: middle;\n          &:hover {\n            background-color:#4cb8ac;\n            color: white;\n          }\n        }\n        .ant-btn-primary{\n          color: white;\n          background-color: #4cb8ac;\n          font-weight: 600;\n          &:hover {\n            background-color: white;\n            color: #4cb8ac;\n          }\n        }\n      }\n    } \n      \n    [nz-radio] {\n      display: block; \n    }\n  }\n}\n\n[nz-radio] {\n  //display: block;\n  height: 32px;\n  line-height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
